// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__7wJGT","description":"style_description__1chTJ","textArea":"style_textArea__JgoIs"};